export enum OrigemEnum {
    PORTAL   = "PORTAL",
    PJE = "PJE-TJRJ",
  }
  